import script from "./ChatPricingModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPricingModal.vue?vue&type=script&setup=true&lang=js"

import "./ChatPricingModal.vue?vue&type=style&index=0&id=a0960042&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0960042"]])

export default __exports__